
//outside this file if i do. obj.spartaData, can that be used as the getter/setter?

/**
 * sparta-global-data-utility
 *
 * Copyright (c) 2016-08-10 Justin Johnson
 */


class spartaGlobalDataUtility {
  constructor(){
  	console.log('%cDEPRECATED ', 'color: red', 'use spartaStore for global data');
  }
}


export default spartaGlobalDataUtility;
